import { IProjectAOI } from "../interfaces/i-project-aoi";
import { MapStatus } from "./map-status";

export class ProjectStatus {
  _multiLayerEnabled: boolean;

  _aois: IProjectAOI[];

  _enabledAOIs: IProjectAOI[];

  _imageAOIs: IProjectAOI[];

  _enabledImageAOIs: IProjectAOI[];

  _centerAOI: IProjectAOI;

  _mapStatus: MapStatus;

  constructor(aois: IProjectAOI[], mapStatus: MapStatus, visibleCollection: string) {
    this.mapStatus = mapStatus;
    this.aois = aois;
    this.calculateCenterCollection(visibleCollection);
  }

  get multiLayerEnabled(): boolean {
    return this._multiLayerEnabled;
  }

  set multiLayerEnabled(value: boolean) {
    this._multiLayerEnabled = value;
  }

  set mapStatus(mapStatus: MapStatus) {
    this._mapStatus = mapStatus;
  }

  get mapStatus(): MapStatus {
    return this._mapStatus;
  }

  set aois(aois: IProjectAOI[]) {
    if (!aois || aois.length === 0) return;

    this._aois = aois?.sort(
      (a1, a2) => a1.nadirDate.getTime() - a2.nadirDate.getTime() || a1.name.localeCompare(a2.name),
    );
    this.imageAOIs = aois?.filter((aoi) => aoi.isAOIOblique());
    this.enabledAOIs = this._aois?.filter((aoi) => aoi.isEnabled());
  }

  get aois(): IProjectAOI[] {
    return this._aois;
  }

  set imageAOIs(aois: IProjectAOI[]) {
    this._imageAOIs = aois.sort((a1, a2) => a1.maxDate.getTime() - a2.maxDate.getTime());
    this.enabledImageAOIs = aois.filter((aoi) => aoi.isEnabled3D() && aoi.isEnabled());
  }

  get imageAOIs(): IProjectAOI[] {
    return this._imageAOIs;
  }

  set enabledAOIs(aois: IProjectAOI[]) {
    this._enabledAOIs = aois;
  }

  calculateCenterCollection(visibleCollection: string) {
    if (!!visibleCollection) {
      this.centerAOI = this.aois.find((aoi) => aoi.name === visibleCollection);
    } else {
      this.centerAOI = null;
    }
  }

  get enabledAOIs(): IProjectAOI[] {
    return this._enabledAOIs;
  }

  set enabledImageAOIs(aois: IProjectAOI[]) {
    this._enabledImageAOIs = aois;
  }

  get enabledImageAOIs(): IProjectAOI[] {
    return this._enabledImageAOIs;
  }

  set centerAOI(aoi: IProjectAOI) {
    this._centerAOI = aoi;
  }

  get centerAOI(): IProjectAOI {
    return this._centerAOI;
  }

  findAOI(aoi: string): IProjectAOI {
    return this.aois.find((p) => p.name === aoi);
  }

  findImageAOI(aoi: string): IProjectAOI {
    return this.imageAOIs.find((p) => p.name === aoi);
  }
}
